import getOrdinal from '../utils/getOrdinal';
import {
  sortCardsOnDropAtEnd,
  sortCardsOnDropBetweenCards,
} from '../sortCards';
import {
  rearrangeOnDraggingBetweenElements,
  rearrangeOnDraggingAtEndOfElements,
} from '../rearrangeCards';
import scrollToElement from '../utils/scrollToElement';

export default (params) => {
  const { el, node, afterOrg, editor, currentNodeKey, dragType } = params;

  const {
    value: { document: editorDocument },
  } = editor;
  const {
    nodes: { size: editorDocumentNodesSize },
  } = editorDocument;
  let orgIndex;
  let paraIndex;
  const currOrgNodeOrdinal = getOrdinal(editorDocument, el);
  const { type: nodeType } = node;

  if (!afterOrg) {
    /**
     * Re position the dragging card and re-arrange the other cards accordingky
     */
    rearrangeOnDraggingAtEndOfElements({
      editor,
      currentNodeKey,
      parent: editorDocument,
      newIndex: editorDocumentNodesSize,
      dragType,
    });

    if (nodeType !== 'skill_organization')
      sortCardsOnDropAtEnd({
        currOrgNodeOrdinal,
        editorDocumentNodesSize,
        editor,
      });

    scrollToElement(el);
  } else {
    const afterOrgNodeOrdinal = getOrdinal(editorDocument, afterOrg);

    /**
     * Re position the dragging card and re-arrange the other cards accordingky
     */
    ({ orgIndex, paraIndex } = rearrangeOnDraggingBetweenElements({
      afterOrgNodeOrdinal,
      currOrgNodeOrdinal,
      orgIndex,
      paraIndex,
      editor,
      currentNodeKey,
      parent: editorDocument,
      dragType,
    }));

    /**
     * Sort cards
     */
    if (nodeType !== 'skill_organization')
      sortCardsOnDropBetweenCards({
        afterOrgNodeOrdinal,
        currOrgNodeOrdinal,
        orgIndex,
        editor,
      });

    scrollToElement(el);
  }
};
